import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/signin',
    name: 'Signin',
    component: () => import('../views/Signin.vue')
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('../views/Signup.vue')
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import('../views/Wallet.vue')
  },
  {
    path: '/transactions',
    name: 'AllTransactions',
    component: () => import('../views/AllTransactions.vue')
  },
  {
    path: '/details/:id',
    name: 'FinanceDetails',
    component: () => import('../views/FinanceDetails.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Signin' && to.name !== 'Signup' && !localStorage.access_token) {
    next({ name: 'Signin' })
  } else if (to.name === 'Signin' && to.name === 'Signup' && localStorage.access_token) {
    next({ name: 'Home' })
  } else {
    console.log('esle')
    next()
  }
})

export default router
